export const APP_DEF_ID = '1522827f-c56c-a5c9-2ac9-00f9e6ae12d3'
export const API_BASE_PATH = '/_api/pricing-plans'
